export const subStepType = {
  INGREDIENTS: "ingredients",
  OUTSIDE_INSTRUCTION: "outsideInstruction",
  INSTRUCTION: "instruction",
  CUSTOM_INSTRUCTION: "customIngredients",
}
